import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DashboardLayout from "../layout/Dashboard";
import { FormattedMessage } from "react-intl";
import { getUserDetails as getAdminUserDetailsApi } from "../../api/admin/users";
import { Messages } from "../../components/layout/Messages/Messages";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import {
  NOTIFICATION_ADMIN_ACTIONS,
  NOTIFICATION_VIEW_ADMIN,
} from '../../config/notifications';
import { UserDetails } from '../../components/pages/admin/users/UserDetails';
import { history } from "../../store/configureStore";
import { ROUTE_ADMIN_MANAGE } from "../../config/routes";
import { DeleteUser } from "../../components/pages/admin/users/table/buttons/DeleteUser";
import { getGroups as getAdminGroups } from "../../api/admin/groups";
import { updateGroupWithUsers as updateGroupWithUsersApi } from "../../api/admin/groups";
import {
  ACL,
  DEFAULT_ADMIN_USER_GROUP_NAME,
  PAGE_CONTEXTS
} from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { store } from '../../store/store';
import { hideNotification } from '../../store/actions/notification';
import { NOTIFICATION_ERROR } from '../../store/actions/types';
import './ViewUser.scss';

function ViewUserComponent(props) {
  const { userId } = props.match.params;
  const [ user, setUser ] = useState( {} );
  const [ groups, setGroups ] = useState( [] );
  const [ groupsUserIsIn, setGroupsUserIsIn ] = useState( null );
  const [ groupsUserIsNotIn, setGroupsUserIsNotIn ] = useState( null );
  const [groupsLoaded, setGroupsLoaded] = useState(false);

  useEffect( () => {
    getUser(userId);

    return () => {
      if (store.getState().notification.type === NOTIFICATION_ERROR) {
        store.dispatch(hideNotification());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );

  useEffect( () => {
    // Create groups user is in and is not in
    if (! groups.length || ! user.id) {
      return;
    }

    let cloneGroupsUserIsIn = [];
    let cloneGroupsUserIsNotIn = [];
    let isGroupOfUser = false;

    groups.forEach( g => {
      isGroupOfUser = false;
      user.groups.forEach( item => {
        if (item.id === g.id) {
          isGroupOfUser = true;
        }
      } );

      if (! isGroupOfUser) {
        cloneGroupsUserIsNotIn.push( g );
      } else {
        cloneGroupsUserIsIn.push( g );
      }
    } );

    setGroupsUserIsNotIn( cloneGroupsUserIsNotIn );
    setGroupsUserIsIn( cloneGroupsUserIsIn );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ groupsLoaded ] )

  /**
   * Get user details
   * @param {string} [userId]
   */
  const getUser = (userId) => {
    if (! ACL.ADMIN.USERS.VIEW.hasAccess()) {
      return;
    }

    getAdminUserDetailsApi( {
      userId: userId,
      notificationId: NOTIFICATION_VIEW_ADMIN,
      pagination: {
        page_context: PAGE_CONTEXTS.ADMIN_USER.VIEW
      }
    } ).then( (response) => {
      if (response && response.data && response.data.id) {
        setUser( response.data );

        getGroups();
      }
    } );
  };

  /**
   * Update user in state after a success update on server
   * @object value
   */
  const updateUser = (value) => {
    setUser( value );
  }

  /**
   * Get admin groups
   */
  const getGroups = () => {
    if (! ACL.ADMIN.GROUPS.LIST.hasAccess() || ! ACL.ADMIN.USERS.VIEW.hasAccess()) {
      return;
    }

    getAdminGroups( {
      disablePagination: true,
    } ).then( (response) => {
      setGroups( response.data );
      setGroupsLoaded(true);
    } );
  };

  const submit = () => {
    let groupsForApi = [];
    groupsUserIsNotIn.forEach(
      group => {
        group.users.forEach(
          (elem, index) => {
            if (elem.id === user.id) {
              group.users.splice( index, 1 );
            }
          }
        );
      }
    );

    groupsForApi = groupsForApi.concat( groupsUserIsNotIn );
    groupsForApi = groupsForApi.concat( groupsUserIsIn );
    let formattedGroupsForApi = [];

    groupsForApi.forEach(
      group => {
        if (group.name !== DEFAULT_ADMIN_USER_GROUP_NAME) {
          formattedGroupsForApi.push( {
            id: group.id,
            users: group.users.map( user => {
              return user.id
            } )
          } );
        }
      }
    );

    updateGroupWithUsersApi( {
      data: {
        groups: formattedGroupsForApi
      },
      notificationId: NOTIFICATION_ADMIN_ACTIONS
    } ).then( () => {
    } );
  };

  const updateGroups = (groupsUser, groupsAdmin) => {
    setGroupsUserIsIn( groupsUser );
    setGroupsUserIsNotIn( groupsAdmin );
  };

  const userName = user && user.id ? [ user.first_name, user.last_name ].filter( Boolean ).join( ' ' ) : '';
  const title = userName || <FormattedMessage id="pages.admin.view_user.title"/>;

  return (
    <DashboardLayout location={props.location} className="dashboard" workspace={true}>
      <PageWorkspace className="admin-user-detail-workspace">
        <PageSurface className="admin-user-detail-surface">
          <PageHeader
            actions={user && user.id && ACL.ADMIN.USERS.DELETE.hasAccess() ? <DeleteUser
              user={user}
              index={1}
              showIcon={false}
              actionCallback={() => history.push( ROUTE_ADMIN_MANAGE )}
            /> : null}
            below={<div className="admin-user-detail-notifications">
              <Messages/>
              <Messages notificationId={NOTIFICATION_ADMIN_ACTIONS}/>
              <Messages notificationId={NOTIFICATION_VIEW_ADMIN}/>
            </div>}
            className="admin-user-detail-header"
            title={title}
          >
            {user && user.id && <div className="admin-user-detail-context">
              <FormattedMessage id="pages.admin.view_user.title"/>
            </div>}
          </PageHeader>
          {!ACL.ADMIN.USERS.VIEW.hasAccess() ? <NoRights/> : <UserDetails
                  location={props.location}
                  user={user}
                  updateUser={updateUser}
                  groupsUserIsIn={groupsUserIsIn}
                  groupsUserIsNotIn={groupsUserIsNotIn}
                  updateGroups={updateGroups}
                  submit={submit}
                />}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ( {} );

const ViewUser = connect( mapStateToProps, null )( ViewUserComponent );

export { ViewUser, ViewUserComponent };
